const BUTTON_CLASS = 'team__button';
const OPEN_CLASS = `${BUTTON_CLASS}--open`;
let isMobile = isInMobileView();

[...document.querySelectorAll('.team')].forEach(team => {
    const BUTTONS = [...team.querySelectorAll(`.${BUTTON_CLASS}`)];
    let activeButton = team.querySelector(`.${OPEN_CLASS}`);

    if (!activeButton && !isInMobileView()) {
        activeButton = handleButton(BUTTONS[0]);
    }

    // Preload images in accordion
    [...team.querySelectorAll('.lazyload')].forEach(image => {
        window.lazySizes.loader.unveil(image);
    });

    team.addEventListener('click', event => {
        let newActiveButton = handleButton(event.target, activeButton, team);
        activeButton = newActiveButton || activeButton;
    });

    let timeout;
    window.addEventListener('resize', () => {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }

        timeout = window.requestAnimationFrame(function() {
            if (isMobile != isInMobileView()) {
                if (isMobile) {
                    const OPEN_BUTTONS = [...team.querySelectorAll(`.${OPEN_CLASS}`)];
                    // The old view was mobile, so we are on desktop
                    if (!OPEN_BUTTONS.length) {
                        // Nothing is open so, we take the first
                        activeButton = BUTTONS[0];
                        toggleSection(activeButton);
                    } else if (OPEN_BUTTONS.length > 1) {
                        OPEN_BUTTONS.forEach(button => {
                            // We close all but not the active (last-clicked) button
                            if (button != activeButton) {
                                toggleSection(button);
                            }
                        });
                    }
                }
                // Invert variable
                isMobile = !isMobile;
            }
        });
    });
});

function handleButton(button, activeButton = false, container = false) {
    if (button.classList.contains(BUTTON_CLASS)) {
        isMobile = isInMobileView();
        if (isMobile) {
            toggleSection(button);
        } else if (!button.classList.contains(OPEN_CLASS)) {
            if (activeButton) {
                toggleSection(activeButton, container, false);
            }
            toggleSection(button, container);
        }
        // Return the active button for later use
        return button;
    }
    return false;
}

function toggleSection(button, container = false, resetContainerHeight = true) {
    // Calculate height and animate it
    const CONTENT = button.nextElementSibling;
    const HEIGHT = [...CONTENT.children].reduce((total, children) => children.offsetHeight + total, 0);
    if (container) {
        container.style.minHeight = `${HEIGHT + button.offsetHeight}px`;
    }

    setTimeout(() => {
        button.classList.toggle(OPEN_CLASS);
    }, 0);

    // after the transition, we set the height to auto
    setTimeout(() => {
        CONTENT.style.height = 'auto';

        if (container && resetContainerHeight) {
            container.style.minHeight = 0;
        }
    }, 400);
}

function isInMobileView() {
    return window.innerWidth < 768;
}
